import styles from './styles.module.css'
import { useTranslation } from 'react-i18next';

export function EmptyLeaderboardState() {
  const { t } = useTranslation();

    return (
        <div className={styles.errorContainer}>
            <p className={styles.errorText}>{t("emptyLeaderBoardState.contentTitle")}</p>
        </div>
    )
}
